<div class="performance-wrapper">
    <div class="banner">
        <div class="main-text-sec container">
            <img src="/assets/images/performance/Performance-headLab-Logo.png" class="img-responsive" />
            <p>
                A central place fueled with executable platform to test your application/service/platform against variety of performance tests in the controlled environment along with guided demos.
            </p>
        </div>
    </div>

    <!-- Features Section -->
    <div class="per-content-body">
        <div class="container features-area">
            <div class="row">
                <div class="col-12 text-right">
                    Quick links :
                    <a [routerLink]="['/endpoint/new']">Create Endpoint</a> | <a href="" [routerLink]="['/testcase/new']">Testcase</a> |
                    <a href="" [routerLink]="['/user/environment-management']">Environment</a>
                  </div>
            </div>
            <div class="row live-sec">
                <img src="/assets/images/performance/live.png" class="flyer-img" />
                <div class="col-4 col-sm-4 col-xs-12">
                    <div class="media">
                        <div class="media-left">
                            <img class="media-object" src="/assets/images/performance/pf1.png" alt="Load Testing" />
                        </div>
                        <div class="media-body">
                            <h4 class="media-heading">Automated load testing </h4>
                            <ul>
                                <li>Self-Service - API load testing Platform</li>
                                <li>Automated UI Load testing for Regression Scenarios</li>
                                <li>Easy Interface for Volume / Batch Job Testing</li>
                            </ul>
                            <a class="perf-btn" routerLink="loadTesting">Get Started</a>
                        </div>
                    </div>
                </div>

                <div class="col-4 col-sm-4 col-xs-12">
                    <div class="media">
                        <div class="media-left">
                            <img class="media-object" src="/assets/images/performance/pf5.png" alt="Load Testing" />
                        </div>
                        <div class="media-body">
                            <h4 class="media-heading">Profiling</h4>
                            <ul>
                                <li>Static Code Profiling for Quality Checks</li>
                                <li>Dynamic Code profiling for App Profile Mgmt</li>
                                <li>CPU & Memory profiling</li>
                            </ul>
                            <a class="perf-btn" href="http://or1010050161037.corp.adobe.com:8080/projects?sort=-analysis_date" target="_blank">Get Started</a>
                        </div>
                    </div>
                </div>

                <div class="col-4 col-sm-4 col-xs-12">
                    <div class="media">
                        <div class="media-left">
                            <img class="media-object" src="/assets/images/performance/pf3.png" alt="Load Testing" />
                        </div>
                        <div class="media-body">
                            <h4 class="media-heading">Simulation</h4>
                            <ul>
                                <li>Load simulation from Multi Geo locations</li>
                                <li>Service Virtualization for Mock - Test environments</li>
                                <li>Test data Simulation for E2E Performance Testing</li>
                            </ul>
                            <a class="perf-btn" routerLink="loadTesting">Get Started</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row coming-soon-sec">
                <img src="/assets/images/performance/comingsoon.png" class="flyer-img" />
                <div class="col-4">
                    <div class="media">
                        <div class="media-left">
                            <img class="media-object" src="/assets/images/performance/pf6.png" alt="Load Testing" />
                        </div>
                        <div class="media-body">
                            <h4 class="media-heading">Dashboard</h4>
                            <ul>
                                <li>Performance trend for Pre Prod & Production</li>
                                <li>API Performance metrics across environments</li>
                                <li>Forecasted release confidence/quality level</li>
                            </ul>
                            <a class="perf-btn in-progress">In-Progress</a>
                        </div>
                    </div>
                </div>

                <div class="col-4">
                    <div class="media">
                        <div class="media-left">
                            <img class="media-object" src="/assets/images/performance/pf2.png" alt="Load Testing" />
                        </div>
                        <div class="media-body">
                            <h4 class="media-heading">Tuning/Optimization</h4>
                            <ul>
                                <li>Client Side ( Browser) Optimization for UEM </li>
                                <li>App Server Tuning ( JVM, thread & Heap dump analysis ) </li>
                                <li>Database Performance Improvement techniques </li>
                            </ul>
                            <a class="perf-btn soon">Coming Soon</a>
                        </div>
                    </div>
                </div>

                <div class="col-4">
                    <div class="media">
                        <div class="media-left">
                            <img class="media-object" src="/assets/images/performance/pf4.png" alt="Load Testing" />
                        </div>
                        <div class="media-body">
                            <h4 class="media-heading">Server Performance Monitoring</h4>
                            <ul>
                                <li>CPU & Memory utilization metrics </li>
                                <li>End user Experience monitoring</li>
                                <li>Cloud Infrastructure metrics Reporting </li>
                            </ul>
                            <a class="perf-btn soon">Coming Soon</a>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</div>